import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '@ant-design/compatible/assets/index.css';

import { Row, message, Alert } from 'antd';
import {
	clearFiltersInvoices,
	fetchInvoices,
	updateFiltersInvoices,
	updatePaginationInvoices,
	updateSortingInvoices,
	replaceFiltersAndSortingInvoices,
	downloadInvoicesCSV,
	fetchInvoiceDownloadFormats,
	downloadInvoiceFormatCSV,
	updateSelection,
	updateInvoiceStatusBulkWrapper,
} from '../../thunks/invoices_thunks_wrapper';
import {
	changeFilterValueToArrayOfIds,
	fetchWithDifferntSearchName,
	getEndDateFieldName,
	getEntitiesById,
	getSelectionObject,
	getStartDateFieldName,
	getTimeZoneFieldName,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import TableHeader from './TableHeader';
import InvoicesListTable from './InvoicesListTable';
import TableFooter from './TableFooter';
import {
	getRecordsForTargetCollection,
	standardInitialStateGenerator,
} from '../../reducers/standard_reducer_utils';
import OWAsyncTreeSelect from '../ow_async_tree_select/OWAsyncTreeSelect';
import {
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	fetchSupplierFacilitiesInPrivateNetworkForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import {
	defaultTimeZone,
	FILTER_CONFIG_NAMES,
	FILTER_FIELD_TYPE,
	FILTER_SEPARATOR,
	FILTER_VALUE_TYPE,
	ROLE_TYPES,
} from '../../utils/DataConstants';
import { unionWith, differenceWith, isEqual } from 'lodash';
import TableSelectionRow from './TableSelectionRow/TableSelectionRow';
import {
	INVOICE_MULTI_SELECT_ACTION_CONFIG_FOR_BUYER,
	INVOICE_MULTI_SELECT_ACTION_CONFIG_FOR_SUPPLIER,
} from './config/multiSelect/multiSelect';
import moment from 'moment';
import OWDateRangePicker from '../ow_date_range_picker/OWDateRangePicker';
import {
	decodeUTCAdjustedDate,
	encodeUTCAdjustedDate,
	formatDateForParam,
} from '../../utils/DataFormatterUtils';
import DeclineInvoiceForm from '../decline_invoice_form/DeclineInvoiceForm';
import {
	assetsRestCrudThunksForBuyer,
	assetsRestCrudThunksForSupplier,
} from '../../thunks/assets_thunks';
import { isInternalTech, isUserManagedBySupplier } from '../../utils/AuthUtils';
import { isSubcontractorInvoiceViewLocation } from '../invoice_utilities/InvoiceUtilities';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import {
	assetTypesRestCrudThunksForBuyer,
	assetTypesRestCrudThunksForSupplier,
} from '../../thunks/asset_types_thunks';
import { AreaTreeSelect } from '../area_tree_select';
import { fetchDistinctAreasHeirarchy } from '../../thunks/areas_thunks';
import { spendCategoriesRestCrudThunksForSupplier } from '../../thunks/spend_categories_thunks';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesRestCrudThunksForSupplier,
} from '../../thunks/work_order_priorities_thunks';
import {
	brandsRestCrudThunksForBuyer,
	brandsRestCrudThunksForSupplier,
} from '../../thunks/brands_thunks';
import { filterValueAccessorDateTime, handleChangeDateTime } from '../../hooks/workOrderHooks';

const TARGETCOLLECTIONNAME = 'invoicesTable';

function InvoicesTable({
	data,
	error,
	openMoreInDefault,
	updatePagination,

	fetchAssetTypes,
	fetchMultipleAssetTypes,
	assetTypes,

	fetchProblemTypes,
	problemTypes,

	fetchAssets,
	fetchMultipleAssets,
	assets,

	fetchAreasDistinct,
	areas,

	fetchSpendCategories,
	fetchMultipleSpendCategories,
	spendCategories,

	workOrderPriorities,
	fetchWorkOrderPriorities,

	brands,
	fetchBrands,
	fetchMultipleBrands,

	invoices,
	invoiceSlice,
	fetchData,
	location,
	updateSorting,
	updateFilters,
	clearFilters,
	companyConfig,
	currentUser,
	downloadInvoicesCSV,
	CustomFooter,
	CustomHeader,
	renderInvoice,
	tableStyle,
	history,
	renderEmptyState,
	invoiceDownloadFormats,
	downloadInvoiceFormatCSV,
	fetchInvoiceDownloadFormats,
	targetCollectionName,
	userType,
	locations,
	supplierFacilities,
	fetchSupplierFacilitiesInPrivateNetwork,
	filterConfig,
	enableViews,
	replaceFiltersAndSorting,
	preAppliedFilters,
	enableMultiSelect,
	updateSelections,
	updateInvoiceStatuses,
	errors,
	enableBannerMessages,
	//loading,
	enableMessaging,
	backText,
}) {
	const {
		filters: activeFilters,
		pagination,
		sorting: activeSorters,
	} = invoices || standardInitialStateGenerator([targetCollectionName]);
	React.useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const preserve = queryParams.has('preserve');
		if (!preserve || !(data && data.length)) {
			fetchData(location);
			if (!CustomHeader) {
				fetchInvoiceDownloadFormats();
			}
		}
	}, []);

	//Statuses
	const { fetching, updating } = invoiceSlice;
	if (enableMessaging) {
		updating
			? message.open({
					key: 'invoiceTableMessageUpdating',
					type: 'loading',
					content: 'Updating...',
					duration: 60,
			  })
			: message.destroy('invoiceTableMessageUpdating');
	}

	const isThirdParty = useMemo(
		() => userType === ROLE_TYPES.SUPPLIER && !isInternalTech(currentUser),
		[currentUser, userType]
	);

	const COMMON_FILTER_CONFIGS = useMemo(
		() => [
			{
				label: 'Location',
				fieldName: 'locationIds',
				mode: 'multiple',
				stateSlice: locations,
				hideFilter: true,
				filtersValueAccessor: (activeFilters) => {
					const locationIds = nullSafeGet(`locationIds`, activeFilters);
					const finalIds = nullSafeGetOrElse(`regionIds`, activeFilters, locationIds);
					return changeFilterValueToArrayOfIds(finalIds);
				},
				keyAccessor: (loc) => loc.id,
				valueAccessor: (loc) => loc.id,
				handleChange: (ids) => {
					updateFilters({
						locationIds: ids.join(',') || undefined,
						regionIds: undefined,
					});
				},
				targetCollectionName: 'invoicesAdvancedFilters',
				fetchMultiple: () => {},
				renderItem: (loc) => loc.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
			},
			{
				label: 'Area',
				fieldName: FILTER_CONFIG_NAMES.AREA,
				mode: 'multiple',
				stateSlice: areas,
				valueType: FILTER_VALUE_TYPE.STRING,
				separator: FILTER_SEPARATOR.TILDE,
				filtersValueAccessor: (filtersStateSlice) => {
					const areaNames = nullSafeGet(FILTER_CONFIG_NAMES.AREA, filtersStateSlice);
					return `${areaNames || ''}`.split(FILTER_SEPARATOR.TILDE).filter((_) => !!_);
				},
				keyAccessor: (area) => area.hierarchyName,
				valueAccessor: (area) => area.hierarchyName,
				labelAccessor: (area) => area.hierarchyName,
				handleChange: (areaNames) => {
					updateFilters({
						[FILTER_CONFIG_NAMES.AREA]: areaNames.join(FILTER_SEPARATOR.TILDE) || undefined,
					});
				},
				targetCollectionName: 'invoicesAdvancedFilters',
				fetch: fetchWithDifferntSearchName(fetchAreasDistinct, 'search'),
				fetchMultiple: () => {},
				renderItem: (area) => area.hierarchyName,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: AreaTreeSelect,
				isSpecial: true,
			},
			{
				label: 'Asset',
				fieldName: FILTER_CONFIG_NAMES.ASSET,
				mode: 'multiple',
				hideFilter: true,
				stateSlice: assets,
				filtersValueAccessor: (activeFilters) => {
					const assetIds = nullSafeGet(`assetIds`, activeFilters);
					return changeFilterValueToArrayOfIds(assetIds);
				},
				keyAccessor: (asset) => asset.id,
				valueAccessor: (asset) => asset.id,
				handleChange: (ids) => {
					updateFilters({ assetIds: ids.join(',') || undefined });
				},
				targetCollectionName: 'invoicesAdvancedFilters',
				fetch: fetchAssets,
				fetchMultiple: fetchMultipleAssets,
				renderItem: (asset) => asset.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: OWAsyncTreeSelect,
			},
			{
				label: 'Problem Type',
				mode: 'multiple',
				fieldName: 'problemTypeIds',
				stateSlice: problemTypes,
				filtersValueAccessor: (filtersStateSlice) => {
					const problemTypeIds = nullSafeGet(`problemTypeIds`, filtersStateSlice);
					return changeFilterValueToArrayOfIds(problemTypeIds);
				},
				keyAccessor: (problemType) => problemType.id,
				valueAccessor: (problemType) => problemType.id,
				handleChange: (ids) => {
					updateFilters({
						problemTypeIds: ids.join(',') || undefined,
					});
				},
				targetCollectionName: 'invoicesAdvancedFilters',
				fetch: fetchProblemTypes,
				fetchMultiple: () => {},
				renderItem: (problemType) => problemType.hierarchyName,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: ProblemTypeTreeSelect,
			},
			{
				label: 'Priority',
				fieldName: 'woPriorityIds',
				mode: 'multiple',
				stateSlice: workOrderPriorities,
				filtersValueAccessor: (filtersStateSlice) => {
					const woPriorityIds = nullSafeGet(`woPriorityIds`, filtersStateSlice);
					return changeFilterValueToArrayOfIds(woPriorityIds);
				},
				keyAccessor: (workOrderPriority) => workOrderPriority.id,
				valueAccessor: (workOrderPriority) => workOrderPriority.id,
				handleChange: (ids) => {
					updateFilters({
						woPriorityIds: ids.join(',') || undefined,
					});
				},
				targetCollectionName: 'workOrdersAdvancedFilters',
				fetch: fetchWorkOrderPriorities,
				fetchMultiple: () => {},
				renderItem: (workOrderPriority) => workOrderPriority.name,
				component: OWAsyncTreeSelect,
			},
			{
				label: 'Published Between',
				labelPrefix: 'Published',
				fieldName: FILTER_CONFIG_NAMES.PUBLISHED_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				filtersValueAccessor: (filtersStateSlice) =>
					filterValueAccessorDateTime(filtersStateSlice, FILTER_CONFIG_NAMES.PUBLISHED_AT),
				handleChange: (values, timeZone = defaultTimeZone) =>
					handleChangeDateTime(updateFilters, FILTER_CONFIG_NAMES.PUBLISHED_AT, values, timeZone),
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				showTimeZone: true,
				additionalDefaultValues: [
					{
						[getTimeZoneFieldName(FILTER_CONFIG_NAMES.PUBLISHED_AT)]: undefined,
					},
				],
				component: OWDateRangePicker,
			},
			{
				label: 'Approved Between',
				labelPrefix: 'Approved',
				fieldName: FILTER_CONFIG_NAMES.APPROVED_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				filtersValueAccessor: (filtersStateSlice) =>
					filterValueAccessorDateTime(filtersStateSlice, FILTER_CONFIG_NAMES.APPROVED_AT),
				handleChange: (values, timeZone = defaultTimeZone) =>
					handleChangeDateTime(updateFilters, FILTER_CONFIG_NAMES.APPROVED_AT, values, timeZone),
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				showTimeZone: true,
				additionalDefaultValues: [
					{
						[getTimeZoneFieldName(FILTER_CONFIG_NAMES.APPROVED_AT)]: undefined,
					},
				],
				component: OWDateRangePicker,
			},
			{
				label: 'Marked Paid Between',
				labelPrefix: 'Marked paid',
				fieldName: FILTER_CONFIG_NAMES.MARKED_PAID_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				filtersValueAccessor: (filtersStateSlice) =>
					filterValueAccessorDateTime(filtersStateSlice, FILTER_CONFIG_NAMES.MARKED_PAID_AT),
				handleChange: (values, timeZone = defaultTimeZone) =>
					handleChangeDateTime(updateFilters, FILTER_CONFIG_NAMES.MARKED_PAID_AT, values, timeZone),
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				showTimeZone: true,
				additionalDefaultValues: [
					{
						[getTimeZoneFieldName(FILTER_CONFIG_NAMES.MARKED_PAID_AT)]: undefined,
					},
				],
				component: OWDateRangePicker,
			},
			{
				label: 'Work Created Between',
				labelPrefix: 'Created',
				fieldName: FILTER_CONFIG_NAMES.CREATED_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				filtersValueAccessor: (filtersStateSlice) =>
					filterValueAccessorDateTime(filtersStateSlice, FILTER_CONFIG_NAMES.CREATED_AT),
				handleChange: (values, timeZone = defaultTimeZone) =>
					handleChangeDateTime(updateFilters, FILTER_CONFIG_NAMES.CREATED_AT, values, timeZone),
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				showTimeZone: true,
				additionalDefaultValues: [
					{
						[getTimeZoneFieldName(FILTER_CONFIG_NAMES.CREATED_AT)]: undefined,
					},
				],
				component: OWDateRangePicker,
			},
			{
				label: 'Work Completed Between',
				labelPrefix: 'Completed',
				fieldName: FILTER_CONFIG_NAMES.COMPLETED_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				filtersValueAccessor: (filtersStateSlice) =>
					filterValueAccessorDateTime(filtersStateSlice, FILTER_CONFIG_NAMES.COMPLETED_AT),
				handleChange: (values, timeZone = defaultTimeZone) =>
					handleChangeDateTime(updateFilters, FILTER_CONFIG_NAMES.COMPLETED_AT, values, timeZone),
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				showTimeZone: true,
				additionalDefaultValues: [
					{
						[getTimeZoneFieldName(FILTER_CONFIG_NAMES.COMPLETED_AT)]: undefined,
					},
				],
				component: OWDateRangePicker,
			},
		],
		[
			locations,
			assets,
			problemTypes,
			areas,
			fetchAreasDistinct,
			fetchProblemTypes,
			fetchAssets,
			fetchMultipleAssets,
			workOrderPriorities,
			fetchWorkOrderPriorities,
			updateFilters,
		]
	);
	const [showDeclineModal, setShowDeclineModal] = useState(false);
	const [declining, setDeclining] = useState(false);

	const handleSubmitDisputeInvoice = (values) => {
		setDeclining(true);
		updateInvoiceStatuses(
			invoices.selections.map((record) => record.id),
			'disputed',
			Object.keys(invoices.selections[0]),
			{
				disputeNote: {
					text: values.note || '',
					noteAddedBy: nullSafeGet('email', currentUser),
					noteAddedAt: moment.utc(),
				},
			}
		)
			.then((data) => {
				setShowDeclineModal(false);
				message.destroy('invoiceTableMessageUpdating');
				message.open({
					key: 'invoiceTableSuccess',
					type: 'success',
					content: data.length.toString().concat(' records updated'),
					duration: 2,
				});
			})
			.catch((error) => {
				message.open({
					key: 'invoiceTableError',
					type: 'error',
					content: error,
					duration: 10,
				});
			})
			.finally(() => setDeclining(false));
	};
	const assignBulkActionFunction = (action) => {
		switch (nullSafeGet('toStatus', action)) {
			case 'disputed':
				return () => setShowDeclineModal(true);
			default:
				return () =>
					updateInvoiceStatuses(
						invoices.selections.map((record) => record.id),
						action.toStatus,
						Object.keys(invoices.selections[0])
					)
						.then((data) => {
							message.destroy('invoiceTableMessageUpdating');
							message.open({
								key: 'invoiceTableSuccess',
								type: 'success',
								content: data.length.toString().concat(' records updated'),
								duration: 2,
							});
						})
						.catch((error) => {
							message.open({
								key: 'invoiceTableError',
								type: 'error',
								content: error,
								duration: 10,
							});
						});
		}
	};
	let actions = (
		userType === 'buyer'
			? INVOICE_MULTI_SELECT_ACTION_CONFIG_FOR_BUYER
			: INVOICE_MULTI_SELECT_ACTION_CONFIG_FOR_SUPPLIER
	).map((action) => {
		return {
			...action,
			fn: assignBulkActionFunction(action),
		};
	});

	let selectItems = enableMultiSelect
		? {
				onSelectCurrentPage: (records) => {
					let keys = unionWith(
						invoices.selections,
						records.map((rec) => getSelectionObject(rec)),
						isEqual
					);
					updateSelections(targetCollectionName, keys);
				},
				onDeselectCurrentPage: (records) => {
					let keys = differenceWith(
						invoices.selections,
						records.map((rec) => getSelectionObject(rec)),
						isEqual
					);
					updateSelections(targetCollectionName, keys);
				},
				onSelectNone: (e) => {
					updateSelections(targetCollectionName, []);
				},
				selections: invoices.selections,
				rowSelection: {
					onSelect: (record, selected, selectedRows, e) => {
						let isSelected = invoices.selections
							.map((item) => item.id)
							.includes(record.id.toString());
						let keys = !isSelected
							? unionWith(invoices.selections, [getSelectionObject(record)], isEqual)
							: differenceWith(invoices.selections, [getSelectionObject(record)], isEqual);
						updateSelections(targetCollectionName, keys);
					},
					selectedRowKeys: invoices.selections.map((item) => item.id),
					preserveSelectedRowKeys: true,
				},
		  }
		: null;

	const BUYER_FILTER_CONFIGS = useMemo(
		() => [
			...(isUserManagedBySupplier(currentUser)
				? []
				: [
						{
							label: 'Supplier',
							fieldName: 'supplierFacilityIds',
							mode: 'multiple',
							stateSlice: supplierFacilities,
							filtersValueAccessor: (filtersStateSlice) =>
								changeFilterValueToArrayOfIds(
									nullSafeGet(`supplierFacilityIds`, filtersStateSlice)
								),
							keyAccessor: (supplierFacility) => supplierFacility.id,
							valueAccessor: (supplierFacility) => supplierFacility.id,
							handleChange: (ids) => {
								updateFilters({
									supplierFacilityIds: ids.join(',') || undefined,
								});
							},
							targetCollectionName: 'invoicesAdvancedFilters',
							fetch: fetchSupplierFacilitiesInPrivateNetwork,
							fetchMultiple: () => {},
							renderItem: (supplierFacility) => supplierFacility.name,
							sortBy: { sort_by: 'name', order: 'ascend' },
							component: OWAsyncTreeSelect,
						},
				  ]),
			{
				label: 'Brands',
				fieldName: 'brandIds',
				mode: 'multiple',
				stateSlice: brands,
				filtersValueAccessor: (filtersStateSlice) => {
					const brandIds = nullSafeGet(`brandIds`, filtersStateSlice);
					return changeFilterValueToArrayOfIds(brandIds);
				},
				keyAccessor: (brand) => brand.id,
				valueAccessor: (brand) => brand.id,
				labelAccessor: (brand) => brand.brandName,
				handleChange: (ids) => {
					updateFilters({
						brandIds: ids.join(',') || undefined,
					});
				},
				targetCollectionName: 'invoicesAdvancedFilters',
				fetch: fetchBrands,
				fetchMultiple: (ids, targetCollectionName) =>
					fetchMultipleBrands(ids, targetCollectionName),
				renderItem: (brand) => brand.brandName,
				renderRecord: (brand) => brand.brandName,
				component: OWAsyncTreeSelect,
			},
			{
				fieldName: FILTER_CONFIG_NAMES.HAS_GL_CODE,
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: 'undefined',
					},
					{
						label: 'Has GL Code',
						value: 'true',
					},
					{
						label: 'No GL Code',
						value: 'false',
					},
				],
				filtersValueAccessor: (filtersStateSlice) => {
					const val = filtersStateSlice[FILTER_CONFIG_NAMES.HAS_GL_CODE];
					return typeof val === 'undefined' ? 'undefined' : `${val}`;
				},
				defaultValue: undefined,
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (value) => {
					const val = value ? value === 'true' : undefined;
					updateFilters({ [FILTER_CONFIG_NAMES.HAS_GL_CODE]: val });
				},
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
			},
			{
				fieldName: FILTER_CONFIG_NAMES.HAS_PO_NUMBER,
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: 'undefined',
					},
					{
						label: 'Has PO Number',
						value: 'true',
					},
					{
						label: 'No PO Number',
						value: 'false',
					},
				],
				filtersValueAccessor: (filtersStateSlice) => {
					const val = filtersStateSlice[FILTER_CONFIG_NAMES.HAS_PO_NUMBER];
					return typeof val === 'undefined' ? 'undefined' : `${val}`;
				},
				defaultValue: undefined,
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (value) => {
					const val = value ? value === 'true' : undefined;
					updateFilters({ [FILTER_CONFIG_NAMES.HAS_PO_NUMBER]: val });
				},
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
			},
			{
				fieldName: 'isCapex',
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: undefined,
					},
					{
						label: 'R&M',
						value: 'false',
					},
					{
						label: 'CapEx',
						value: 'true',
					},
				],
				filtersValueAccessor: (filtersStateSlice) => {
					const val = filtersStateSlice.isCapex;
					return typeof val === 'undefined' ? undefined : `${val}`;
				},
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (isCapex) => {
					const val = isCapex ? isCapex === 'true' : undefined;
					updateFilters({ isCapex: val });
				},
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
				info: [
					{
						title: 'Repair and Maintenance (R&M)',
						description: 'Costs associated with repair and maintenance of existing assets',
					},
					{
						title: 'Capital Expenditures (CapEx)',
						description: 'Costs associated with buying new assets or upgrading existing assets',
					},
				],
			},
			{
				fieldName: 'isPM',
				type: 'radioGroup',
				items: [
					{
						label: 'All',
						value: undefined,
					},
					{
						label: 'Planned',
						value: 'true',
					},
					{
						label: 'Reactive',
						value: 'false',
					},
				],
				filtersValueAccessor: (filtersStateSlice) => {
					const val = filtersStateSlice.isPM;
					return typeof val === 'undefined' ? undefined : `${val}`;
				},
				keyAccessor: (item) => item.value,
				valueAccessor: (item) => item.value,
				handleChange: (isPM) => {
					const val = isPM ? isPM === 'true' : undefined;
					updateFilters({ isPM: val });
				},
				renderRecord: (item) => item.label,
				component: OWRadioGroup,
				info: [
					{
						title: 'Planned',
						description: `Scheduled maintenance work generated based on planned maintenance system.`,
					},
					{
						title: 'Reactive',
						description: `On demand maintenance work requested by your team or suggested by a service provider.`,
					},
				],
			},
		],
		[
			currentUser,
			supplierFacilities,
			fetchSupplierFacilitiesInPrivateNetwork,
			brands,
			fetchBrands,
			fetchMultipleBrands,
			updateFilters,
		]
	);

	const SUPPLIER_FILTER_CONFIGS = useMemo(
		() => [
			{
				label: 'Created Between',
				labelPrefix: 'Created',
				fieldName: FILTER_CONFIG_NAMES.CREATED_AT,
				type: FILTER_FIELD_TYPE.DATE_RANGE,
				filtersValueAccessor: (filtersStateSlice) => {
					const startDate =
						filtersStateSlice[getStartDateFieldName(FILTER_CONFIG_NAMES.CREATED_AT)];
					const endDate = filtersStateSlice[getEndDateFieldName(FILTER_CONFIG_NAMES.CREATED_AT)];
					return [startDate && moment(startDate), endDate && moment(endDate)];
				},
				handleChange: (values) => {
					updateFilters({
						[getStartDateFieldName(FILTER_CONFIG_NAMES.CREATED_AT)]:
							values && values.length > 1 && values[0] ? formatDateForParam(values[0]) : undefined,
						[getEndDateFieldName(FILTER_CONFIG_NAMES.CREATED_AT)]:
							values && values.length > 1 && values[1] ? formatDateForParam(values[1]) : undefined,
					});
				},
				renderRecord: (item) => item,
				valueAccessor: (item) => item,
				component: OWDateRangePicker,
			},
			{
				label: 'Trade',
				fieldName: 'spendCategoryIds',
				mode: 'multiple',
				stateSlice: spendCategories,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(`spendCategoryIds`, filtersStateSlice);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (spendCategory) => spendCategory.id,
				valueAccessor: (spendCategory) => spendCategory.id,
				handleChange: (ids) => updateFilters({ spendCategoryIds: ids.join(',') || undefined }),
				targetCollectionName: 'invoicesAdvancedFilters',
				fetch: fetchSpendCategories,
				fetchMultiple: fetchMultipleSpendCategories,
				renderItem: (spendCategory) => spendCategory.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: OWAsyncTreeSelect,
			},
		],
		[spendCategories, updateFilters]
	);

	const FILTER_CONFIG = useMemo(() => {
		const defaultConfig: any[] =
			userType === ROLE_TYPES.SUPPLIER
				? [
						...COMMON_FILTER_CONFIGS,
						...SUPPLIER_FILTER_CONFIGS,
						...(isInternalTech(currentUser) ? BUYER_FILTER_CONFIGS : []),
				  ]
				: [...COMMON_FILTER_CONFIGS, ...BUYER_FILTER_CONFIGS];
		const advancedFilterConfig =
			filterConfig && filterConfig.filters && filterConfig.filters.length > 0
				? filterConfig.filters.map((filter) => defaultConfig.find((_) => _.fieldName === filter))
				: defaultConfig;
		return {
			...(filterConfig || {}),
			filters: advancedFilterConfig
				.filter((_) => !!_)
				.sort((a, b) => (b.mode === 'multiple') - (a.mode === 'multiple')),
		};
	}, [
		userType,
		COMMON_FILTER_CONFIGS,
		SUPPLIER_FILTER_CONFIGS,
		currentUser,
		BUYER_FILTER_CONFIGS,
		filterConfig,
	]);

	return (
		<div>
			{CustomHeader ? (
				<CustomHeader
					applySorting={updateSorting}
					applyFilters={(e) => updateFilters(e)}
					filters={activeFilters}
					sorters={activeSorters}
					downloadCSV={() => downloadInvoicesCSV({}, activeFilters)}
					counts={invoiceSlice.counts}
					filterConfig={FILTER_CONFIG}
					clearFilters={clearFilters}
					targetCollectionName={targetCollectionName}
					userType={userType}
					pagination={pagination}
					fetching={fetching}
					location={location}
					currentUser={currentUser}
				/>
			) : (
				<TableHeader
					applySorting={updateSorting}
					applyFilters={(e) => updateFilters(e)}
					filters={activeFilters}
					sorters={activeSorters}
					downloadCSV={() => downloadInvoicesCSV({}, activeFilters)}
					counts={invoiceSlice.counts}
					filterConfig={FILTER_CONFIG}
					clearFilters={clearFilters}
					targetCollectionName={targetCollectionName}
					enableViews={enableViews}
					userType={userType}
					applyFiltersFromView={replaceFiltersAndSorting}
					preAppliedFilters={preAppliedFilters}
					downloadInvoiceFormatCSV={(key) => downloadInvoiceFormatCSV(key, {}, activeFilters)}
					invoiceDownloadFormatRecords={getRecordsForTargetCollection(
						invoiceDownloadFormats,
						'invoiceFormatsIndex'
					)}
					fetching={fetching}
					location={location}
					currentUser={currentUser}
				/>
			)}

			<div style={{ marginTop: 16, marginLeft: 4, background: 'white' }}>
				{enableBannerMessages &&
				nullSafeGet('filters.statuses', invoiceSlice[targetCollectionName]) === 'Draft' ? (
					<Row>
						<Alert
							style={{ width: '100%', padding: '8px 9px', borderWidth: 0 }}
							type={'warning'}
							showIcon
							message={
								<span style={{ paddingLeft: '16px' }}>
									Drafted invoices can't be seen by your customers. Please make sure to submit your
									invoice once work has been completed.
								</span>
							}
						/>
					</Row>
				) : null}
				{enableMultiSelect ? (
					<TableSelectionRow
						selectItems={selectItems}
						actions={actions}
						records={data}
						counts={invoiceSlice.counts}
						updatePagination={updatePagination}
						pagination={pagination}
						updating={updating}
						errors={errors}
						currentUser={currentUser}
					/>
				) : null}
				<DeclineInvoiceForm
					visible={showDeclineModal}
					onCancel={() => setShowDeclineModal(false)}
					onSubmit={handleSubmitDisputeInvoice}
					declining={declining}
				/>
				<InvoicesListTable
					fetching={fetching}
					data={data}
					currentUser={currentUser}
					companyConfig={companyConfig}
					renderInvoice={renderInvoice}
					refreshTable={fetchData}
					tableStyle={tableStyle}
					renderEmptyState={renderEmptyState}
					location={location}
					userType={userType}
					selectItems={selectItems}
					enableMultiSelect={enableMultiSelect}
					backText={backText}
					targetCollectionName={targetCollectionName}
				/>
				{CustomFooter ? (
					<CustomFooter
						updatePagination={updatePagination}
						pagination={{ ...pagination, current: 1, pageSize: 3 }}
						filters={activeFilters}
						sorter={activeSorters}
						location={location}
						history={history}
						enableMultiSelect={enableMultiSelect}
						openMoreInDefault={openMoreInDefault}
						userType={userType}
					/>
				) : (
					<Row justify="end">
						<TableFooter
							records={data}
							//enableMultiSelect={enableMultiSelect}
							updatePagination={updatePagination}
							pagination={
								pagination && pagination.total && pagination.total !== 0 ? pagination : null
							}
							//selectItems={selectItems}
						/>
					</Row>
				)}
			</div>
		</div>
	);
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	handleQueryParams: ownProps.handleQueryParams,
	locations: state.locations,
	errors: state.session.errors,
	loading: state.session.loading,
	spendCategories: state.spend_categories,
	problemTypes: state.problem_types,
	regions: state.regions,
	areas: state.areas,
	supplierFacilities: state.supplier_facilities,
	invoices: state.invoices[ownProps.targetCollectionName || TARGETCOLLECTIONNAME],
	invoiceSlice: state.invoices,
	assetTypes: state.asset_types,
	assets: state.assets,
	companyConfig: state.company_config.detail,
	targetCollectionName: ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
	data: getEntitiesById(
		state.invoices[ownProps.targetCollectionName || TARGETCOLLECTIONNAME]
			? state.invoices[ownProps.targetCollectionName || TARGETCOLLECTIONNAME].recordsIds || []
			: [],
		state.invoices.records
	),
	invoiceDownloadFormats: state.invoice_download_formats,
	workOrderPriorities: state.work_order_priorities,
	brands: state.brands,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchData: (location) =>
		dispatch(
			fetchInvoices(ownProps.userType)(
				ownProps.handleQueryParams,
				ownProps.history,
				location,
				ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
				ownProps.preAppliedFilters,
				ownProps.initialPagination,
				ownProps.initialSorting,
				ownProps.initialFilters,
				ownProps.ignoreRefreshCounts
			)
		),
	updatePagination: (pagination) =>
		dispatch(
			updatePaginationInvoices(ownProps.userType)(
				ownProps.handleQueryParams,
				ownProps.history,
				ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
				pagination,
				ownProps.ignoreRefreshCounts
			)
		),
	updateSorting: (sorting) =>
		dispatch(
			updateSortingInvoices(ownProps.userType)(
				ownProps.handleQueryParams,
				ownProps.history,
				ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
				sorting,
				ownProps.ignoreRefreshCounts
			)
		),
	updateFilters: (filters) =>
		dispatch(
			updateFiltersInvoices(ownProps.userType)(
				ownProps.handleQueryParams,
				ownProps.history,
				ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
				filters,
				ownProps.ignoreRefreshCounts
			)
		),
	updateSelections: (targetCollectionName, selections) =>
		dispatch(
			updateSelection(ownProps.userType)(
				ownProps.handleQueryParams,
				ownProps.history,
				ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
				selections
			)
		),
	replaceFiltersAndSorting: (filters, sorting) =>
		dispatch(
			replaceFiltersAndSortingInvoices(ownProps.userType)(
				ownProps.handleQueryParams,
				ownProps.history,
				ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
				filters,
				sorting,
				ownProps.ignoreRefreshCounts
			)
		),
	clearFilters: () =>
		dispatch(
			clearFiltersInvoices(ownProps.userType)(
				ownProps.handleQueryParams,
				ownProps.history,
				ownProps.targetCollectionName || TARGETCOLLECTIONNAME,
				ownProps.preAppliedFilters,
				ownProps.ignoreRefreshCounts
			)
		),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? fetchSupplierFacilitiesInPrivateNetworkForSupplier
				: fetchSupplierFacilitiesInPrivateNetworkForBuyer;
		return dispatch(
			fnToCall(
				params,
				targetCollectionName || TARGETCOLLECTIONNAME,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		);
	},
	downloadInvoicesCSV: (params, filters) =>
		dispatch(
			downloadInvoicesCSV(ownProps.userType, isSubcontractorInvoiceViewLocation(ownProps.location))(
				params,
				filters
			)
		),
	fetchInvoiceDownloadFormats: (params) =>
		dispatch(fetchInvoiceDownloadFormats(ownProps.userType)(params)),
	downloadInvoiceFormatCSV: (formatName, params, filters) =>
		dispatch(downloadInvoiceFormatCSV(ownProps.userType)(formatName, params, filters)),
	updateInvoiceStatuses: (ids, status, invoiceParams, additionalParams = {}) =>
		dispatch(
			updateInvoiceStatusBulkWrapper(ownProps.userType)(
				ids,
				status,
				TARGETCOLLECTIONNAME,
				invoiceParams,
				additionalParams
			)
		),
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetsRestCrudThunksForSupplier.readLite
				: assetsRestCrudThunksForBuyer.readLite;
		return dispatch(
			fnToCall(
				params,
				targetCollectionName || TARGETCOLLECTIONNAME,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		);
	},
	fetchMultipleAssets: (ids, targetCollectionName) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetsRestCrudThunksForSupplier.readLite
				: assetsRestCrudThunksForBuyer.readLite;
		return dispatch(fnToCall({ ids }, targetCollectionName || TARGETCOLLECTIONNAME));
	},
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier
				: problemTypesHeirarchicalForBuyer;
		return dispatch(
			fnToCall(
				params,
				targetCollectionName || TARGETCOLLECTIONNAME,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		);
	},
	fetchAssetTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetTypesRestCrudThunksForSupplier
				: assetTypesRestCrudThunksForBuyer;
		return dispatch(
			fnToCall.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName || TARGETCOLLECTIONNAME,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		);
	},
	fetchMultipleAssetTypes: (ids, targetCollectionName) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetTypesRestCrudThunksForSupplier
				: assetTypesRestCrudThunksForBuyer;
		return dispatch(fnToCall.readMultiple(ids, targetCollectionName));
	},
	fetchAreasDistinct: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchDistinctAreasHeirarchy(ownProps.userType)(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchSpendCategories: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			spendCategoriesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleSpendCategories: (ids, targetCollectionName) =>
		dispatch(spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchWorkOrderPriorities: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderPrioritiesRestCrudThunksForSupplier
				: workOrderPrioritiesRestCrudThunksForBuyer;
		return dispatch(
			fnToCall.read(
				params,
				targetCollectionName || TARGETCOLLECTIONNAME,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		);
	},
	fetchBrands: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.read
				: brandsRestCrudThunksForBuyer.read;
		return dispatch(
			fnToCall(params, targetCollectionName, pagination, sorting, filters, addToTargetCollection)
		);
	},
	fetchMultipleBrands: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: brandsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
});

const InvoicesHOC = withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoicesTable));

export default connect(
	(state) => ({
		userType: state.session.userType,
		currentUser: state.session.currentUser,
	}),
	(dispatch, ownProps) => ({})
)(InvoicesHOC);
